import { useMediaQuery, useTheme } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
  fetchOrderDataAction,
  createShippingLabelAction,
  setOpenModalAction
} from '../../store/order/reducer'
import {
  selectListedItem,
  selectOrderHeader,
  selectOrderLoadingPage,
  selectLoadingError,
  selectCreateShippingLabelError,
  selectIsOpenModal
} from '../../store/order/selectors'

export const useOrder = () => {
  const theme = useTheme()
  const fullscreen = useMediaQuery(theme.breakpoints.down('sm'))
  const dispatch = useDispatch()
  const { orderId } = useParams<{ orderId: string }>()
  const listedItem = useSelector(selectListedItem)
  const orderHeader = useSelector(selectOrderHeader)
  const loadingPage = useSelector(selectOrderLoadingPage)
  const loadingError = useSelector(selectLoadingError)
  const createShippingLabelError = useSelector(selectCreateShippingLabelError)
  const isOpen = useSelector(selectIsOpenModal)


  //SetIsOpen
  const setIsOpen = (status: boolean) => {
    dispatch(setOpenModalAction(status))
  }

  //Get Order Data
  const getOrderData = () => {
    dispatch(fetchOrderDataAction(orderId as string))
  }

  //Create Shipping Label
  const createShippingLabel = () => {
    setIsOpen(true)
    !orderHeader.shipment &&
      dispatch(
        createShippingLabelAction({ orderid: orderHeader.orderHeaderId })
      )
  }

  return {
    //props
    isOpen,
    setIsOpen,
    fullscreen,
    orderHeader,
    listedItem,
    loadingPage,
    loadingError,
    createShippingLabelError,

    //methods
    getOrderData,
    createShippingLabel,
  }
}
